var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"swiper",staticClass:"swiper"},[_c('div',{staticClass:"swiper-wrapper"},[_vm._t("default")],2),_vm._v(" "),_vm._t("pagination",function(){return [_c('div',{ref:"pagination",staticClass:"swiper-pagination"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }